import { FC } from 'react';

import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { Button } from '$uikit';
import { useTranslator } from '$hooks';

import { DateRangeSection, DateRangePreset } from './DateRangeSection';

export interface DateRangeSheetProps {
  preset: DateRangePreset;
  startDay: number;
  endDay: number;
  onChange: (preset: DateRangePreset, startDay: number, endDay: number) => void;
  onClose: () => void;
}

export const DateRangeSheet: FC<DateRangeSheetProps> = ({
  preset,
  startDay,
  endDay,
  onChange,
  onClose,
}) => {
  const t = useTranslator();
  return (
    <BottomSheet
      title={t('statistics_pro_period')}
      onClose={onClose}
      className="ActionBottomSheet"
    >
      <div className="ActionBottomSheet__content">
        <DateRangeSection
          preset={preset}
          startDay={startDay}
          endDay={endDay}
          onChange={onChange}
          onPick={(next) => {
            if (next !== 'custom') {
              onClose();
            }
          }}
        />
        {preset === 'custom' && (
          <div className="ActionBottomSheet__footer">
            <Button stretched onClick={onClose}>
              {t('statistics_pro_apply')}
            </Button>
          </div>
        )}
      </div>
    </BottomSheet>
  );
};
